var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBreasts4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 59,
  fill: "none",
  viewBox: "0 0 30 59"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1.95 1c2.26 4.149 5.57 8.627 7.48 10.276C15.48 16.515 29 20.143 29 31.28c0 11.137-13.5 14.805-13.5 14.805s-.09 1.84-.04 3.679c.1 3.459-.16 4.598-.24 8.237"
})));
export default SvgBreasts4;